/** @file This file contains utilities to work with errors. */
/**
 * Convert a value to an error.
 *
 * If the given value is already an error it will be returned as is, if the value is `null` we
 * will provide a special message.
 *
 * @param x The value that should be converted to an error.
 * @returns The converted error.
 */
export function coerceToError(x) {
    if (x instanceof Error) {
        return x;
    }
    else if (x == null) {
        return new Error('Got an undefined value as error');
    }
    else {
        return new Error(String(x));
    }
}
